import React from 'react';
import { FaChartArea, FaTable, FaSolarPanel } from 'react-icons/fa';
import { BsPlus, BsGearFill, BsChatFill } from 'react-icons/bs';
import { RiLogoutCircleLine } from 'react-icons/ri';
import './sidebar.css';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import { setTab } from '../../../redux/actions/sideBarAction';
import { useNavigate } from 'react-router-dom';
import { LogoutAction } from '../../../redux/actions/authAction';

export default function SideBar() {
	const { selectedTab } = useTypedSelector((state) => state.sidebar);

	const Divider = () => <hr className="sidebar-hr" />;
	return (
		<div className="sidebar">
			<SideBarIcon
				icon={<BsPlus size="32" />}
				text="Create topic ➕"
				selectedTab="add-topic"
				isActive={selectedTab === 'add-topic'}
			/>

			<Divider />
			<SideBarIcon
				icon={<FaSolarPanel size="24" />}
				text="Extensions 🔮"
				selectedTab="extensions"
				isActive={selectedTab === 'extensions'}
			/>

			<Divider />
			<SideBarIcon
				icon={<FaChartArea size="24" />}
				text="Dashboard 📊"
				selectedTab="dashboard"
				isActive={selectedTab === 'dashboard'}
			/>

			<SideBarIcon
				icon={<FaTable size="20" />}
				text="Documents 📋"
				selectedTab="documents"
				isActive={selectedTab === 'documents'}
			/>

			<SideBarIcon
				icon={<BsChatFill size="20" />}
				text="Outreach 📟"
				selectedTab="outreach"
				isActive={selectedTab === 'outreach'}
			/>

			<Divider />

			<SideBarIcon
				icon={<BsGearFill size="22" />}
				text="Settings 🔧"
				selectedTab="settings"
				isActive={selectedTab === 'settings'}
			/>

			<div className="mt-auto">
				<LogoutIcon />
			</div>
		</div>
	);
}

type SideBarProps = {
	icon: JSX.Element;
	text?: string;
	selectedTab: string;
	isActive: boolean;
};

const SideBarIcon = ({
	icon,
	text = 'tooltip 💡',
	selectedTab,
	isActive = false
}: SideBarProps) => {
	const dispatch = useDispatch();

	const navigate = useNavigate();
	function handleClick() {
		navigate(selectedTab);
	}

	return (
		<div
			className={'group ' + (isActive ? 'sidebar-icon-active' : 'sidebar-icon')}
			onClick={() => {
				handleClick();
				return dispatch(setTab(selectedTab));
			}}
		>
			{icon}
			<span className="sidebar-tooltip group-hover:scale-100">{text}</span>
		</div>
	);
};

const LogoutIcon = () => {
	const dispatch = useDispatch();
	function handleClick() {
		dispatch(LogoutAction());
	}

	return (
		<div
			className={'group ' + 'sidebar-logout-icon'}
			onClick={() => {
				handleClick();
			}}
		>
			<RiLogoutCircleLine size="28" />
			<span className="sidebar-tooltip group-hover:scale-100">logout 💔</span>
		</div>
	);
};
